import { OnChanges } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { Output } from '@angular/core';
import { Input } from '@angular/core';
import { Component } from '@angular/core';
import { PublishersSelectors } from 'app/modules/communication-centre/advertiser/store/publishers/publishers.selectors';
import { Localisation } from 'app/modules/main/components/data-selector/data-selector.models';
import { SelectableData } from 'app/modules/main/components/data-selector/data-selector.models';
import { PublisherClassFilter } from 'app/modules/main/components/publisher-selector/publisher-class-filter.service';
import { PublisherColumnExtractor } from 'app/modules/main/components/publisher-selector/publisher-column-extractor.service';
import { PublisherSelectorMapper } from 'app/modules/main/components/publisher-selector/publisher-selector-mapper';
import { PublisherAccount } from 'app/modules/main/models/account';
import { BehaviorSubject } from 'rxjs';
import { take } from 'rxjs/operators';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-publisher-selector',
  templateUrl: './publisher-selector.component.html',
})
export class PublisherSelectorComponent implements OnChanges {

  @Input() readonly open: boolean = false;
  @Input() readonly required: boolean = false;
  @Input() readonly singular: boolean = false;

  @Input() readonly localisation?: Localisation = {
    title: $localize`:@@communication-centre.advertiser.publisher-selector.title:Select Publishers`,
    closeLabel: $localize`:@@communication-centre.advertiser.publisher-selector.label.close:Close`,
    searchLabel: $localize`:@@communication-centre.advertiser.publisher-selector.label.search:Search`,
    searchPlaceholder: $localize`:@@communication-centre.advertiser.publisher-selector.label.search-placeholder:Name or ID`,
    allCategoriesLabel: $localize`:@@communication-centre.advertiser.publisher-selector.label.all-categories:All`,
    selectAllLabel: $localize`:@@communication-centre.advertiser.publisher-selector.label.select-all:All`,
    selectNoneLabel: $localize`:@@communication-centre.advertiser.publisher-selector.label.select-none:None`,
    itemHeaderLabel: $localize`:@@communication-centre.advertiser.publisher-selector.label.item-header:Item`,
    selectHeaderLabel: $localize`:@@communication-centre.advertiser.publisher-selector.label.select-header:Select`,
    noDataText: $localize`:@@communication-centre.advertiser.publisher-selector.no-data:You have no publishers joined`,
    noMatchesText: $localize`:@@communication-centre.advertiser.publisher-selector.no-matches:Your filter criteria did not return any results.`,
    cancelLabel: $localize`:@@communication-centre.advertiser.publisher-selector.button.cancel:Cancel`,
    submitLabel: $localize`:@@communication-centre.advertiser.publisher-selector.button.submit:Select`,
  };

  @Input() readonly selectedPublishers: PublisherAccount[];

  @Output() readonly submitted = new EventEmitter<PublisherAccount[]>();
  @Output() readonly cancelled = new EventEmitter<void>();

  private initialized = false;

  readonly selectablePublishers = new BehaviorSubject<SelectableData<PublisherAccount>[]>(null);

  constructor(
    readonly publisherColumnExtractor: PublisherColumnExtractor,
    readonly publisherClassFilter: PublisherClassFilter,
    private readonly publisherSelectorMapper: PublisherSelectorMapper,
    private readonly publishersSelectors: PublishersSelectors,
  ) {
  }

  ngOnChanges(): void {

    if (this.initialized || this.selectedPublishers === null) {
      return;
    }

    this.initialized = true;

    this.publishersSelectors.getPublishers()
      .pipe(
        take(1),
        map(publishers => this.publisherSelectorMapper.toSelectablePublishers(publishers, this.selectedPublishers)),
      )
      .subscribe(selectablePublishers => this.selectablePublishers.next(selectablePublishers));
  }

  public cancel(): void {
    this.cancelled.emit();
  }

  public submit(
    selectedPublishers: SelectableData<PublisherAccount>[]
  ): void {

    const publishers = this.publisherSelectorMapper.toPublisherAccount(selectedPublishers);

    this.submitted.emit(publishers);
  }

}
